// src/components/table/PushDevices.tsx

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { useEffect, useState } from 'react'

import { decodeAppleModel } from '../../api'
import { svgConstants as SVG } from '../../constants'
import { OperatorData, useOperator } from '../../hooks'

const renderReportLevel = mask => {
  let build = []

  switch (mask) {
    case 0:
      build = []
      break
    case 1:
      build = [SVG.CATEGORY_FEELING_INACTIVE]
      break
    case 2:
      build = [SVG.CATEGORY_SECURITY_INACTIVE]
      break
    case 3:
      build = [SVG.CATEGORY_FEELING_INACTIVE, SVG.CATEGORY_SECURITY_INACTIVE]
      break
    case 4:
      build = [SVG.CATEGORY_PERFORMANCE_INACTIVE]
      break
    case 5:
      build = [SVG.CATEGORY_FEELING_INACTIVE, SVG.CATEGORY_PERFORMANCE_INACTIVE]
      break
    case 6:
      build = [
        SVG.CATEGORY_SECURITY_INACTIVE,
        SVG.CATEGORY_PERFORMANCE_INACTIVE,
      ]
      break
    case 7:
      build = [
        SVG.CATEGORY_FEELING_INACTIVE,
        SVG.CATEGORY_SECURITY_INACTIVE,
        SVG.CATEGORY_PERFORMANCE_INACTIVE,
      ]
      break
    default:
      console.error('unhandled mask:', mask)
      break
  }

  return build.map(item => (
    <Box
      alt={''}
      component={'img'}
      key={item}
      src={`${window.location.origin}${item}`}
      sx={{ width: 30, mr: 1 }}
    />
  ))
}

export const PushDevices = () => {
  const opData: OperatorData = useOperator()

  const [data, setData] = useState([])

  useEffect(() => {
    if (!opData?.devices) return
    setData(opData.devices)
  }, [opData?.devices])

  return (
    <TableContainer>
      <Table>
        <TableHead sx={{ backgroundColor: 'lightgrey' }}>
          <TableRow>
            <TableCell>Gerät</TableCell>

            <TableCell align={'right'}>Report Level</TableCell>

            <TableCell align={'right'}>Status</TableCell>

            <TableCell align={'right'}>registriert am</TableCell>

            <TableCell align={'right'}>aktualisiert am</TableCell>

            <TableCell align={'right'}>Dienstanbieter</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map(device => (
            <TableRow key={device.model}>
              <TableCell>{decodeAppleModel(device.model)}</TableCell>

              <TableCell align={'right'}>
                {renderReportLevel(device.push_mask)}
              </TableCell>

              <TableCell align={'right'}>
                {['deakiviert', 'aktiviert'][device.enabled]}
              </TableCell>

              <TableCell align={'right'}>
                {new Date(device.created_at).toLocaleString()}
              </TableCell>

              <TableCell align={'right'}>
                {new Date(device.updated_at).toLocaleString()}
              </TableCell>

              <TableCell align={'right'}>{device.provider}</TableCell>
            </TableRow>
          ))}

          {data.length === 0 && (
            <TableRow>
              <TableCell align={'center'} colSpan={3}>
                Kein Gerät registriert.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
